import React from 'react'
import { NavLink } from 'react-router-dom'
import AccordionWrap from '../../component/Other/AccordionWrap'
import Navbar from '../../component/Other/Navbar'
import ContactForm from '../../component/Page/ContactForm'
import Footer from '../../component/Page/Footer'
import SecContact from '../../component/Page/Contact'

const Contact = () => {
    const faqData = [
        {
            title: "What is a wedding planner?",
            desc: 'A wedding planner is a person or team appointed to assist in preparing, organizing, and executing a wedding to run smoothly and in line with the wishes of the bride and groom.'
        },
        {
            title: "Why do I need a wedding planner?",
            desc: 'A wedding planner is a person or team appointed to assist in preparing, organizing, and executing a wedding to run smoothly and in line with the wishes of the bride and groom.'
        },
        {
            title: "What services are provided by a wedding planner? ",
            desc: 'A wedding planner is a person or team appointed to assist in preparing, organizing, and executing a wedding to run smoothly and in line with the wishes of the bride and groom.'
        },
    ]
    return (
        <div className="overflow-hidden">
            <Navbar type={"dark"} />

            <ContactForm />

            <section>
                <div className="container">
                    <div className="mb-5">
                        <h2 className="medium font__size--48 text__48-1024 text__48-md text__48-sm play">Frequently
                            asked questions</h2>
                        <p className="normal font__size--18 text__18-1024 opacity__8">If you have questions that are not listed here, <br className='d-none d-md-block' />
                            send them to us via <a href="#!" className="wrapper__link-underline">email.</a>
                        </p>
                    </div>
                    {
                        faqData.map((obj) => {
                            return <AccordionWrap data={obj} />
                        })
                    }


                    <div className="text-center mt-5">
                        <NavLink
                            to="/faq" className="medium font__size--14 text__14-1024 btn btn__outlined--darkgreen color__darkgreen shadow text-capitalize rounded__50 h__white no__opacity pointer" >See All</NavLink>
                    </div>

                </div>
            </section>

            <SecContact />

            <Footer />
        </div >
    )
}

export default Contact